import { Button } from '../../../../../../components/button/button';
import { Modal, ModalProps } from '../../../../../../components/modal/modal';
import { useLang } from '../../../../../../hooks/use-lang';
import s from './unlink-employee-modal.module.css';
import { useEmployeesStore } from '../../../../../../store/use-employee-store';
import { useQueryParams } from '../../../../../../hooks/use-query-params';

export const UnlinkEmployeeModal = (props: ModalProps) => {
  const { t } = useLang();
  const { isLoading, unlinkEmployee } = useEmployeesStore();

  const params = useQueryParams().getQueryParams();
  const id = params.id;
  const name = params.name;

  const handleConfirm = async () => {
    try {
      await unlinkEmployee(id);
      props.onClose();
    } catch (e) {
      console.error(e);
    }
  };

  return (
    <Modal {...props} title={t('Разавторизация сотрудника')} className={s.feature}>
      <label>{t('Вы действительно хотите разавторизовать сотрудника {{name}}?', { name })}</label>
      <div className={s.controls}>
        <Button variant="secondary" onClick={props.onClose} disabled={isLoading}>
          {t('Назад')}
        </Button>
        <Button variant="danger" onClick={handleConfirm} disabled={isLoading}>
          {t('Разавторизовать')}
        </Button>
      </div>
    </Modal>
  );
};
